import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

interface Props {
  visual: React.ReactNode;
  title: string;
  description: React.ReactNode;
}

const useStyles = makeStyles(() =>
  createStyles({
    background: {
      background: '#F7FCFF',
      minHeight: '100vh',
      textAlign: 'center'
    },
    header: {
      backgroundColor: 'var(--color-key)',
      padding: '20px 16px 24px'
    },
    headerTitle: {
      margin: 0,
      color: 'var(--color-white)',
      fontSize: 16,
      letterSpacing: '0.08em',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    contents: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 200px)',
      padding: '40px 16px'
    },
    heading: {
      margin: '40px 0 0',
      color: 'var(--color-text)',
      fontSize: 22,
      fontWeight: 'normal',
      letterSpacing: '0.5px',
      textAlign: 'center'
    },
    description: {
      margin: '16px 0 0',
      color: 'var(--color-text)',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '24px',
      textAlign: 'center'
    }
  })
);

const ErrorScreen: React.FC<Props> = ({ visual, title, description }) => {
  const styles = useStyles({});

  return (
    <div className={styles.background}>
      <div className={styles.header}>
        <h1 className={styles.headerTitle}>{'スマモル賃貸サービスお申し込み'}</h1>
      </div>
      <div className={styles.contents}>
        {visual}
        <h2 className={styles.heading}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
};

export default ErrorScreen;
